export default "__VITE_PUBLIC_ASSET__e1756abc__"